import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from '@shared/components/button/button.module';
import { ScrollToTopComponent } from './scroll-to-top.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule
  ],
  declarations: [ScrollToTopComponent],
  exports: [ScrollToTopComponent]
})
export class ScrollToTopModule { }
